
import { UITableViewCell, UILabel, UITextField, UIButton, UIControl } from "uikit";
import { CartLine, DLDB } from "dldb";

export interface BookingReviewCellDelegate
{
    onProductDidChange ( cell: BookingReviewCell, numberOfProducts:number, line:CartLine ) : void ;
}


export class BookingReviewCell extends UITableViewCell
{
    delegate: BookingReviewCellDelegate = null;

    private nameLabel: UILabel;
    private priceLabel: UILabel;
    private quantityTextField: UITextField;
    private plusButton: UIButton;
    private minusButton: UIButton;

    awakeFromNib ( ) {      
        this.plusButton.addTarget( this, this.onPlus, UIControl.Event.touchUpInside );
        this.minusButton.addTarget( this, this.onMinus, UIControl.Event.touchUpInside );
    }

    private _line: CartLine = null;
    set item( line: CartLine ) {
        this._line = line;
        this.nameLabel.text = line.productName;
        this.priceLabel.text = DLDB.shared.currencyFormatter().stringFromNumber( line.productPrice );
        this.quantityTextField.text = line.quantity.toString();
    }

     private onPlus ( ) {
        const value = parseInt( this.quantityTextField.text, 10 ) + 1;
        this.quantityTextField.text = value.toString();
        this.delegate?.onProductDidChange( this, 1, this._line );
    }

    private onMinus ( ) {
        const value = parseInt( this.quantityTextField.text, 10 ) - 1;
        if ( value == -1 ) return ;
        this.quantityTextField.text = value.toString();
        this.delegate?.onProductDidChange( this, -1, this._line );
    }
}